import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import PageHeader from "@core/components/pageHeader";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import { useLocation } from "react-router-dom";
import Utility from "@core/helper/utility";
import { useSelector } from "react-redux";
import AddhijriCalendar from "views/pages/calendar/hijiridates/AddHijricalendar";
import HijriCalendraList from "views/pages/calendar/hijiridates/HijariCalendarList";
import Loader from "@core/helper/Loader";

const HijriCalendar = () => {
  const [openModal, setOpenModal] = useState(false);
  const [type, setType] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [hijriCalendarList, setHijriCalendarList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [updateData, setUpdateData] = useState(null);
  const [totalRecord, setTotalRecord] = useState("");
  const [permission, setPermission] = useState({});
  const [role, setRole] = useState("");
  const { userData } = useSelector((state) => state.auth);
  const location = useLocation();
  const handleDeleteModal = (id) => {
    if (id) {
      const payload = { id };
      APICall("delete", payload, EndPoints.deleteHijriDate)
        .then((response) => {
          const { isError, message } = response.data;
          if (response.status === 200 && !isError) {
            toast.success(message);
            const filter = hijriCalendarList.filter((o) => o.id !== id);
            setHijriCalendarList(filter);
            fetchHijriCalendarList();
          }
        })
        .catch((error) => {
          return error;
        });
    }
    setDeleteOpen(!deleteOpen);
  };

  const handleOpen = (type, id) => {
    setOpenModal(!openModal);
    setSearchText("");
    setType(type);
    if (id) {
      const findList = hijriCalendarList.find((o) => o.id === id);
      setUpdateData(findList);
    }
  };
  useEffect(() => {
    if (userData.data.user.role === "2") {
      const hijricalender = Utility.getUserData({
        datastore: userData,
        activePath: location.pathname,
      });
      setPermission(hijricalender[1]);
    } else {
      setPermission({});
    }

    setRole(userData.data.user.role);
  }, [location.pathname, userData]);

  useEffect(() => {
    fetchHijriCalendarList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, pageSize, pageNumber]);

  const fetchHijriCalendarList = () => {
    Loader.isLoading(true);

    const payload = {
      pageNo: pageNumber + 1,
      limit: pageSize,
      orderBy: "DESC",
    };
    APICall("post", payload, EndPoints.getHijriDate)
      .then((response) => {
        const { results, totalCount } = response.data.data;
        if (response.status === 200 && results) {
          setHijriCalendarList(results);
          setTotalRecord(totalCount);
        } else {
          setHijriCalendarList([]);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };

  const submitHijriCalendar = () => {
    fetchHijriCalendarList();
  };

  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
            Hijri Calendar
          </Typography>
        }
      />
      {((permission.view && role === "2") || role === "1") && (
        <Grid item xs={12}>
          <HijriCalendraList
            handleDeleteModal={handleDeleteModal}
            deleteOpen={deleteOpen}
            handleOpen={handleOpen}
            hijriCalendarList={hijriCalendarList}
            pageSize={pageSize}
            setPageSize={setPageSize}
            searchText={searchText}
            setSearchText={setSearchText}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            totalRecord={totalRecord}
            permission={permission}
            role={role}
          />
        </Grid>
      )}
      {openModal && (
        <AddhijriCalendar
          onSubmitHijriCalendar={submitHijriCalendar}
          open={openModal}
          toggle={handleOpen}
          type={type}
          heading={
            type === "edit" ? "Update Hijri Calendar" : "Add Hijri Calendar "
          }
          updateData={updateData}
          permission={permission}
        />
      )}
    </Grid>
  );
};

export default HijriCalendar;
